import { SizeType } from '../types/asset-types';

export function getAspectRatio(size: SizeType): number {
  switch (size) {
    case 'LANDSCAPE':
      return 16 / 9;
    case 'PORTRAIT':
      return 9 / 16;
    case 'SQUARE':
      return 1;
    default:
      return 1;
  }
}
